module.exports = __webpack_public_path__ + "img/kgz.1cfa1c79.svg";